import productSliders from 'mixins/product-sliders'
import registerImageZoom from 'modules/global/image-zoom/vue-image-zoom.vue.js'
import Vue from 'vue'

// vue-image-zoom is no longer rendered by Liquid (was inline-template),
// so init() won't find [is="vue-image-zoom"] in DOM — register it explicitly.
registerImageZoom()

/**
 * Product Gallery component
 */
Vue.component('product-gallery', resolve => {
  Promise.all([
    enqueueModule('vue-image-zoom.vue')
  ]).then(() => resolve({
    template: `
      <div class="product-gallery" v-if="activeVariant">
        <div class="product-gallery__top">
          <div class="js-product-featured js-product-sliders product-gallery__featured" :style="featuredStyle">
            <div
              class="product-gallery__featured__slide js-product-slide"
              @click="openZoomGallery(image.src)"
              :data-color-variant="slug(image.alt)"
              v-for="(image, index) in productImages">
              <div class="product-gallery__featured__image">
                <vue-image-zoom
                  :src="image.src"
                  :size="768"
                  :alt="sanitizedAltText(image.alt)"
                  :width="image.width"
                  :height="image.height"
                  css="product-gallery__img"
                  fit="cover"
                  pos="center"
                  :lazy="index !== 0"
                  :transition="true"
                  :transparent="true"></vue-image-zoom>
              </div>
            </div>
          </div>
        </div>
        <div class="product-gallery__bottom">
          <div class="js-product-thumbs js-product-sliders product-gallery__thumbs">
            <div
              @click="currentThumbSlide"
              class="product-gallery__thumbs__slide js-product-slide"
              :data-color-variant="slug(image.alt)"
              v-for="(image, index) in productImages">
              <div class="product-gallery__thumbs__image">
                <vue-image
                  :src="image.src"
                  :transparent="true"
                  :alt="sanitizedAltText(image.alt)"
                  :width="image.width"
                  :height="image.height"
                  :size="130"
                  fit="contain"
                  spinner="sm"
                  css="fit-contain"></vue-image>
              </div>
            </div>
          </div>
        </div>
      </div>
    `,
    props: ['videosHtml'],
    mixins: [productSliders],
    computed: {

      featuredStyle () {
        const [image] = this.productImages
        const ratio = image ? Number(image.height) / Number(image.width) : 0

        return Number.isFinite(ratio) && ratio > 0
          ? { '--product-gallery-slide-ratio': ratio }
          : {}
      }
    },
    watch: {
      activeVariant () {
        this.checkProductImages()

        this.startImageFiltering('.js-product-sliders')
      }
    },
    mounted () {
      if (this.videosHtml) {
        const featured = this.$el.querySelector('.js-product-featured')
        const temp = document.createElement('div')
        temp.innerHTML = this.videosHtml
        while (temp.firstChild) {
          featured.appendChild(temp.firstChild)
        }
      }

      this.checkProductImages()

      this.initializeSliders('.js-product-featured', '.js-product-thumbs')

      this.startImageFiltering('.js-product-sliders')

      this.replacePagination()
    },
    methods: {
      openZoomGallery (imageSrc) {
        this.$parent.$emit('showZoomGallery', imageSrc)
      }
    }
  }))
})
